exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".PowerSources__power-sources___32KI-{position:absolute;top:50px;left:50px;display:flex;user-select:none}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game/power-sources/PowerSources.scss"],"names":[],"mappings":"AAAA,qCAAe,kBAAkB,SAAS,UAAU,aAAa,gBAAgB,CAAC","file":"PowerSources.scss","sourcesContent":[".power-sources{position:absolute;top:50px;left:50px;display:flex;user-select:none}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"power-sources": "PowerSources__power-sources___32KI-",
	"powerSources": "PowerSources__power-sources___32KI-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib?{"modules":true,"importLoaders":1,"sourceMap":true,"localIdentName":"[name]__[local]___[hash:base64:5]","camelCase":true,"namedExport":true,"url":false}!./node_modules/sass-loader/lib/loader.js!./src/ts/app/screens/game/power-sources/PowerSources.scss
// module id = 247
// module chunks = 0